<template>
  <StudioMultiSelect
    v-model="itemsSelected"
    :searchable="true"
    :items="selectItems"
    :label="label"
    :placeholder="placeholder"
    :clearable="clearable"
    @clearClick="$emit('clearInfo', label)"
  >
    <template v-slot:selection="{index}">
      <span
        v-if="index === minimumFilterView"
        class="grey--text caption"
      >
        {{ itemsSelected.length }} {{ message }}
      </span>
    </template>
  </StudioMultiSelect>
</template>

<script>
import { mapActions } from 'vuex';
import StudioMultiSelect from '@/components/filter/models/StudioMultiSelect';
import blipModel from '@/mixins/blip-model';

export default {
  name: 'OperatorsFilter',
  components: {
    StudioMultiSelect,
  },
  mixins: [
    blipModel,
  ],
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    contracts: {
      type: Object,
      default: () => ({}),
    },
    bots: {
      type: Object,
      default: () => ({}),
    },
    label: {
      type: String,
      default: 'Agentes',
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      minimumFilterView: 0,
      selectItems: [],
    };
  },
  computed: {
    placeholder() {
      return this.$t('components.filters.OperatorsFilter.placeholder');
    },
    itemsSelected: {
      get() {
        if (this.value && this.value.value) {
          return this.value.value;
        }

        return [];
      },
      set(newValue) {
        let newTypes = newValue;

        if (!newValue?.length) {
          return this.$emit('input', undefined);
        }

        if (typeof (newValue[0]) === 'object') {
          newTypes = newValue.map(v => v && v.value);
        }

        this.$emit('input', {
          value: newTypes,
          selected: this.selectItems.filter(item => newTypes.includes(item.value)),
        });
      },
    },
    message() {
      return this.itemsSelected.length - this.minimumFilterView === 1
        ? this.$t('components.filters.OperatorsFilter.selected')
        : this.$t('components.filters.OperatorsFilter.selectedPlural');
    },
  },
  watch: {
    computedContracts: {
      immediate: true,
      handler() {
        this.updateSelectItems();
      },
    },
    computedBots: {
      immediate: true,
      handler() {
        this.updateSelectItems();
      },
    },
  },
  methods: {
    ...mapActions('cards', [
      'getDeskService',
    ]),
    async updateSelectItems() {
      if (!this.computedContracts.value || !this.computedBots.value) {
        this.selectItems = [];
        return;
      }
      const operatorsItems = await this.getOperatorsItems(this.computedContracts, this.computedBots);
      this.selectItems = operatorsItems.map(agent => ({
        text: agent.fullName,
        value: agent.email,
      }));
    },
    async getOperatorsItems(contracts, bots) {
      if (bots?.value) {
        try {
          const responseStack = await this.getDeskService({
            servicePath: 'getDeskAgents',
            contracts: contracts.value,
            bots: bots.value,
            itemId: this.itemId,
          });

          const operatorsItems = responseStack.map(({ status, reason, resource }) => {
            if (status === 'failure' && reason.code !== 67) throw new Error(reason.description);
            return resource?.items.length ? resource?.items : [];
          })
            .flat()
            .filter((item, index, itemsStack) => itemsStack.findIndex(itemOfStack => itemOfStack.email === item.email) === index);

          return operatorsItems;
        } catch (e) {
          console.error(e);
          return [];
        }
      }
      return [];
    },
  },
};

</script>

<style scoped lang="scss">
  .v-select__selection.v-select__selection--comma {
    line-height: 120%;
  }
</style>
